import { useEffect } from 'react';
import { connect } from 'react-redux';
import styled, { css } from 'styled-components';
import Progress from '@clds/progress';
import { InfiniteWindowedGridLayout } from '@cld/react-window-layout';
import t from 'common/i18n';
import NoResults from 'root/components/NoResults';
import bindActions, { types as ats } from '../../actions';
import { selectSort, selectOrderBy, selectSearchTerm, selectIsSearch } from '../../selectors';
import {
  selectNavigationFolderId,
  selectNavigationPreviousFolder,
  selectNavigationDriveId,
  selectNavigationKind,
  selectFiles,
  selectFolders,
  selectFoldersCursor,
  selectFoldersIsPending,
  selectFilesIsPending,
  selectFilesCursor,
  selectFilesIsInit,
  selectFoldersLoadingIsDone,
  selectIsLoading,
  selectIsNoResults,
  selectSelectedFiles,
  selectNavigationPath,
} from '../../selectors/navigationSelectors';
import { useFilesSection, useFoldersSection } from './sections';

import SVG_ICONS from '~/assets/icons/icons';
import { DEFAULT_GRID_IMAGE_WIDTH } from '~/src/root/components/ResultImageGrid/VirtualResultsGrid/const';

const { LOAD_NAVIGATION_FOLDERS, LOAD_SEARCH_FOLDERS, SET_BREADCRUMBS_PATH } = ats;

const centerContentCss = css`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  ${({ isCenter }) => isCenter && centerContentCss}
`;

const ResultsGrid = (props) => {
  const { actions, folderId, folderPath, previousFolder, folderKind, folderDriveId, sort, orderBy, term, isLoading, noResults, isSearch } = props;

  useEffect(() => {
    if (!term) {
      actions[LOAD_NAVIGATION_FOLDERS]({
        id: folderId,
        path: folderPath,
        previousFolder,
        kind: folderKind,
        driveId: folderDriveId,
        sort,
        orderBy,
      });
    }
  }, [actions, term, folderId, folderPath, previousFolder, folderKind, folderDriveId, sort, orderBy]);

  useEffect(() => {
    if (term) {
      actions[LOAD_SEARCH_FOLDERS]({ term });
    }
  }, [actions, term]);

  useEffect(() => {
    actions[SET_BREADCRUMBS_PATH]();
  }, [actions, folderId]);

  const sections = [useFoldersSection(props), useFilesSection(props)];

  return (
    <Wrapper isCenter={isLoading || noResults}>
      <InfiniteWindowedGridLayout itemWidth={props.itemWidth || DEFAULT_GRID_IMAGE_WIDTH} sections={sections} />
      {isLoading ? (
        <Progress.Circular size="xl" variant="primary" />
      ) : noResults ? (
        <NoResults icon={isSearch ? null : SVG_ICONS.FILE} text={isSearch ? null : t('google_drive.grid.empty_folder')} />
      ) : null}
    </Wrapper>
  );
};

const mapStateToProps = (state) => ({
  folderId: selectNavigationFolderId(state),
  folderPath: selectNavigationPath(state),
  folderKind: selectNavigationKind(state),
  folderDriveId: selectNavigationDriveId(state),
  previousFolder: selectNavigationPreviousFolder(state),
  sort: selectSort(state),
  orderBy: selectOrderBy(state),
  term: selectSearchTerm(state),
  folders: selectFolders(state),
  foldersCursor: selectFoldersCursor(state),
  foldersIsPending: selectFoldersIsPending(state),
  folderLoadingIsDone: selectFoldersLoadingIsDone(state),
  files: selectFiles(state),
  selectedFiles: selectSelectedFiles(state),
  filesCursor: selectFilesCursor(state),
  filesIsPending: selectFilesIsPending(state),
  filesIsInit: selectFilesIsInit(state),
  isLoading: selectIsLoading(state),
  noResults: selectIsNoResults(state),
  isSearch: selectIsSearch(state),
});

export default connect(mapStateToProps, (dispatch) => ({
  actions: bindActions(dispatch),
}))(ResultsGrid);
